<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Threshold Ramp';
                }
            },
            profile: {
                required: true
            },
            threshold: {
                required: true
            },
            doorRange: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.profile, this.threshold, this.doorRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-ramp?profile=' + this.profile + '&threshold=' + this.threshold + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.profile + '_' + this.threshold + '_' + this.doorRange;
            }
        },
        watch: {
            'profile': function (val, oldVal) {
                this.update_options();
            },
            'threshold': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
